import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, saveAuth } from "../lib/nurseryApi";
import { ArrowRight, Leaf } from "@phosphor-icons/react";

export default function Login() {
  const [email, setEmail] = useState("demo@nurserysense.com");
  const [password, setPassword] = useState("demo1234");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      saveAuth(data.token, data.user);
      // Admins land directly in the admin area; owners go to their dashboard
      nav(data.user?.is_admin ? "/admin" : "/app/dashboard");
    } catch (e) {
      setErr(e?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="organic-bg" style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 24 }}>
      <div className="card-soft" style={{ width: "100%", maxWidth: 460, padding: 36, borderRadius: 24 }}>
        <Link to="/" style={{ fontSize: 12, fontWeight: 700, color: "var(--secondary)", letterSpacing: "0.1em", textTransform: "uppercase", textDecoration: "none" }} data-testid="back-home">← Back home</Link>
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginTop: 14 }}>
          <div style={{ width: 44, height: 44, background: "var(--primary)", borderRadius: 14, display: "grid", placeItems: "center" }}>
            <Leaf size={22} color="white" weight="fill" />
          </div>
          <h1 className="font-display" style={{ fontSize: 40, lineHeight: 1 }}>Welcome back</h1>
        </div>
        <p style={{ marginTop: 14, color: "var(--muted-fg)", fontSize: 14.5 }}>Demo: <b style={{ color: "var(--text)" }}>demo@nurserysense.com</b> / <b style={{ color: "var(--text)" }}>demo1234</b></p>
        <form onSubmit={submit} style={{ marginTop: 24, display: "flex", flexDirection: "column", gap: 16 }}>
          <div>
            <label className="label">Email</label>
            <input className="input" value={email} onChange={(e) => setEmail(e.target.value)} required type="email" data-testid="login-email-input" />
          </div>
          <div>
            <label className="label">Password</label>
            <input className="input" value={password} onChange={(e) => setPassword(e.target.value)} required type="password" data-testid="login-password-input" />
          </div>
          {err && <div className="badge badge-danger" data-testid="login-error">{err}</div>}
          <button className="btn btn-primary" type="submit" disabled={loading} data-testid="login-submit-btn" style={{ padding: "15px 24px" }}>
            {loading ? "Signing in..." : <>Sign in <ArrowRight size={16} weight="bold" /></>}
          </button>
        </form>
        <div style={{ marginTop: 22, fontSize: 14, color: "var(--text-soft)" }}>
          New here? <Link to="/apply" style={{ fontWeight: 700, color: "var(--primary)", textDecoration: "underline" }} data-testid="goto-register">Apply to be a Founding Nursery</Link>
        </div>
      </div>
    </div>
  );
}
